import React from 'react';

interface PdfExtProps {
    width?: number;
    height?: number;
}

export const PdfExt = ({ height = 26, width = 26 }: PdfExtProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
    >
        <g clipPath="url(#clip0_5885_18301)">
            <path
                d="M23.3269 5.11064L18.4519 0.235638C18.376 0.160337 18.2859 0.100762 18.1869 0.0603282C18.0879 0.0198946 17.9819 -0.000601989 17.875 1.34596e-05H4.875C3.52879 1.34596e-05 2.4375 1.0913 2.4375 2.43751V23.5625C2.4375 24.9087 3.52879 26 4.875 26H21.125C22.4712 26 23.5625 24.9087 23.5625 23.5625V5.68751C23.5631 5.58058 23.5426 5.47458 23.5022 5.37559C23.4618 5.27659 23.4022 5.18656 23.3269 5.11064ZM21.9375 23.5625C21.9375 24.0113 21.5738 24.375 21.125 24.375H4.875C4.42625 24.375 4.0625 24.0113 4.0625 23.5625V2.43751C4.0625 1.98876 4.42625 1.62501 4.875 1.62501H17.0625V4.87501C17.0625 5.77247 17.79 6.50001 18.6875 6.50001H21.9375V23.5625Z"
                fill="#D7D7D7"
            />
            <path
                d="M20 21.1667C20 21.625 19.625 22 19.1667 22H0.833333C0.375 22 0 21.625 0 21.1667V12.8333C0 12.375 0.375 12 0.833333 12H19.1667C19.625 12 20 12.375 20 12.8333V21.1667Z"
                fill="#F15642"
            />
            <path
                d="M13.8539 19.4971H13.0404V14.5H15.8636V15.1904H13.8539V16.749H15.7338V17.436H13.8539V19.4971Z"
                fill="white"
            />
            <path
                d="M12.1636 16.9507C12.1636 17.5135 12.0588 17.984 11.8491 18.3623C11.6395 18.7383 11.3353 19.022 10.9365 19.2134C10.5378 19.4025 10.057 19.4971 9.49414 19.4971H8.10645V14.5H9.64453C10.1618 14.5 10.6084 14.5934 10.9844 14.7803C11.3604 14.9648 11.6509 15.2394 11.856 15.604C12.061 15.9663 12.1636 16.4152 12.1636 16.9507ZM11.3091 16.9746C11.3091 16.5645 11.2441 16.2272 11.1143 15.9629C10.9867 15.6986 10.7975 15.5026 10.5469 15.375C10.2985 15.2451 9.99202 15.1802 9.62744 15.1802H8.92676V18.8101H9.50781C10.1117 18.8101 10.5628 18.6562 10.8613 18.3486C11.1598 18.041 11.3091 17.583 11.3091 16.9746Z"
                fill="white"
            />
            <path
                d="M5.45264 14.5C6.09749 14.5 6.56803 14.6322 6.86426 14.8965C7.16048 15.1608 7.30859 15.5311 7.30859 16.0073C7.30859 16.2238 7.27441 16.43 7.20605 16.626C7.13997 16.8197 7.0306 16.9917 6.87793 17.1421C6.72526 17.2902 6.5236 17.4076 6.27295 17.4941C6.02458 17.5807 5.7181 17.624 5.35352 17.624H4.82031V19.4971H4V14.5H5.45264ZM5.39795 15.1802H4.82031V16.9404H5.26807C5.52555 16.9404 5.7443 16.9108 5.92432 16.8516C6.10433 16.79 6.24105 16.6932 6.33447 16.561C6.4279 16.4289 6.47461 16.2546 6.47461 16.0381C6.47461 15.7487 6.38688 15.5334 6.21143 15.3921C6.03825 15.2508 5.76709 15.1802 5.39795 15.1802Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_5885_18301">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
